import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onStartCallViaSipProtocol = action('onStartCallViaSipProtocol', event => ({
    event,
    owaType: 'startCallViaSipProtocol',
})) as OwaNovaActionUnion<'startCallViaSipProtocol'>;
